import api from "./api";

const ServicePlanAPI = {
    getAll: () => api.get("/service-plan/all"),
    getByServiceType: (serviceTypeId) => api.get(`/service-plan/service-type/${serviceTypeId}`),
    getById: (servicePlanId) => api.get(`/service-plan/details/${servicePlanId}`),
    update: (params) => api.post(`/service-plan/update`, params),
    getPlanFeatureByUser: () => api.get(`/service-plan/feature`)
};

export default ServicePlanAPI;